const namespaced = true

const state = {
  selectedPackage: null,
  packageQty: 1,
  packageId: null,
}

const mutations = {
  refreshPackages(state, packages) {
    state.selectedPackage = packages[0]
  },
  updateSelectedPackage(state, chosenPackage){
    state.selectedPackage = chosenPackage
  },
  updatePackageQty(state, packageQty){
    state.packageQty = packageQty
  },
  setPackageId(state, packageId) {
    state.packageId = packageId
  }
}

export default {
  namespaced,
  state,
  mutations
}
